module.exports = __webpack_public_path__ + "img/author.4b962106.jpg";